<template>
  <div class="gridBox">
    <div class="tabContro van-hairline--bottom">
      <div class="tit"><svg-icon icon-class="fill" style="margin-right:4px;"></svg-icon>出差费用报销文件.doc</div>
      <div class="del">删除</div>
    </div>
    <div class="add noCopy" onbeforecopy='return false'>
        <van-button><svg-icon icon-class="shangchuan" style="margin-right:4px;"/>上传文件</van-button>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>